// import { createPaginationReducer } from 'reducers/index.js'
import { searchChess } from 'actions/building'
import { createReducer } from 'redux-act'

const createPaginationReducer = (action) => {
  const defaultsState = {
    loading: false,
    request: null,
    data: null,
    error: null,
    offset: 0,
    finished: false,
  }

  return createReducer({
    [action.request]: (state, payload) => ({
      ...state,
      request: payload,
      loading: true,
      error: null,
    }),
    [action.ok]: (state, payload) => {
      const data = payload.request[0].offset === 0 ?
        payload.response.rows :
        [...state.data, ...payload.response.rows]
      return {
        ...state,
        loading: false,
        finished: data.length >= payload.response.total,
        offset: (payload.request[0].offset === 0 ? 0 : state.offset) + payload.request[0].limit,
        total: payload.response.total,
        data,
      }
    },
    [action.error]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
  }, defaultsState)
}

const reducer = createPaginationReducer(searchChess)

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/flats.js